import { render, staticRenderFns } from "./deleteAccount.vue?vue&type=template&id=18c95e77"
import script from "./deleteAccount.vue?vue&type=script&lang=js"
export * from "./deleteAccount.vue?vue&type=script&lang=js"
import style0 from "./deleteAccount.vue?vue&type=style&index=0&id=18c95e77&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports